export default __webpack_public_path__ + "static/media/avatar-alcides_antonio.c7942fad.png";